import React from 'react';

export const ScrollFrame = ({ text1, seperator, text2, text3 }) => {
	// Base repeating sequence
	const sequence = [text1, seperator, text2, seperator, text3, seperator];

	// How many times the sequence repeats inside one wrapper
	const REPEAT_COUNT = 6;

	// Renders one wrapper (used twice for infinite scroll)
	const renderWrapper = (ariaHidden = false) => (
		<div className="wrapper" aria-hidden={ariaHidden}>
			{Array.from({ length: REPEAT_COUNT }).flatMap((_, repeatIndex) =>
				sequence.map((text, index) => (
					<div className="module-text" key={`${repeatIndex}-${index}`}>
						<span data-text={text}>{text}</span>
					</div>
				))
			)}
		</div>
	);

	// Renders one frame edge (top, bottom, left, right)
	const renderFrameEdge = (position, direction) => (
		<div className={`frame-edge ${position}`} aria-hidden="true">
			<div className={`row-infinite-scroll ${direction}`}>
				{renderWrapper(false)}
				{renderWrapper(true)}
			</div>
		</div>
	);

	return (
		<>
			{renderFrameEdge('top', 'horizontal')}
			{renderFrameEdge('bottom', 'horizontal')}
			{renderFrameEdge('left', 'vertical')}
			{renderFrameEdge('right', 'vertical')}
		</>
	);
};
